module.exports = __webpack_public_path__ + "static/media/MTRG-BUSD.9bc89c88.svg";